import { Package } from 'lucide-react';
import { useTranslation } from '../../../i18n';
import { SectionHead } from '../SectionHead';
import { ObjectChip } from '../ObjectChip';

export interface MaterialItem {
  taskId?: string;
  objectId?: string | null;
  taskName: string;
  objectName: string;
  name: string;
  quantity?: string | null;
}

interface Props {
  materials: MaterialItem[];
}

export function MaterialsCard({ materials }: Props) {
  const { t } = useTranslation('dashboard');

  return (
    <div className="rounded-xl border border-border bg-surface dark:bg-slate-900 dark:border-slate-700 p-4 sm:p-5">
      <SectionHead
        kicker={t('materials.kicker')}
        title={t('materials.title')}
        action={
          <Package
            className="w-4 h-4 text-ink-subtle dark:text-slate-500"
            aria-hidden
          />
        }
      />
      <div className="mt-4 space-y-2">
        {materials.length === 0 ? (
          <div className="rounded-lg border border-dashed border-border bg-surface-muted dark:bg-slate-800/50 dark:border-slate-700 p-4 text-center text-xs text-ink-muted dark:text-slate-400">
            {t('materials.empty')}
          </div>
        ) : (
          materials.map((mat, idx) => (
            <div
              key={`${mat.taskId ?? 'm'}-${idx}-${mat.name}`}
              className="flex items-center justify-between gap-3 rounded-lg bg-surface-muted dark:bg-slate-800/40 px-3 py-2"
            >
              <div className="min-w-0">
                <div className="text-sm font-medium text-ink dark:text-slate-50 truncate">
                  {mat.name}
                </div>
                <div className="text-[11px] text-ink-muted dark:text-slate-400 truncate">
                  {mat.taskName}
                </div>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                {mat.quantity && (
                  <span className="font-mono-num text-xs text-ink-muted dark:text-slate-300">
                    {mat.quantity}
                  </span>
                )}
                <ObjectChip
                  objectKey={mat.objectId ?? mat.objectName}
                  label={mat.objectName}
                />
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
